'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = [{
    title: '模版编号',
    dataIndex: 'id',
    key: 'id'
}, {
    title: '默认图',
    dataIndex: 'thumb',
    key: 'thumb',
    render: function render(text) {
        return _react2.default.createElement('img', { src: text + '!160x160', className: 'thumb' });
    }
}, {
    title: '模版名称',
    dataIndex: 'name',
    key: 'name',
    render: function render(text, record) {
        return _react2.default.createElement(
            'span',
            null,
            record.title,
            ' \u2014\u2014 ',
            record.subTitle
        );
    }
}, {
    title: '适用类型',
    key: 'type',
    render: function render(text, record) {
        return record.type.name;
    }
}, {
    title: '序号',
    dataIndex: 'sort',
    key: 'sort'
}, {
    title: '状态',
    key: 'status',
    render: function render(text, record) {
        return record.status === 1 ? '上架' : '下架';
    }
}, {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at'
}, {
    title: '操作',
    key: 'action',
    render: function render(text, record) {
        return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                _reactRouter.Link,
                { to: '/templates/' + record.id },
                '\u7F16\u8F91'
            ),
            _react2.default.createElement('span', { className: 'ant-divider' }),
            _react2.default.createElement(
                'a',
                { onClick: record.handleStatusChange.bind(null, record.id, record.status) },
                ' ',
                record.status === 1 ? '下架' : '上架',
                ' '
            ),
            _react2.default.createElement('span', { className: 'ant-divider' }),
            _react2.default.createElement(
                'a',
                { onClick: record.handleDelete.bind(null, record.id) },
                '\u5220\u9664'
            )
        );
    }
}];

var TemplateList = _react2.default.createClass({
    displayName: 'TemplateList',

    propTypes: {
        templates: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var _props = this.props,
            templates = _props.templates,
            handleStatusChange = _props.handleStatusChange,
            handleDelete = _props.handleDelete;
        var items = templates.items,
            pagination = templates.pagination,
            error = templates.error,
            isFetching = templates.isFetching,
            isPosting = templates.isPosting;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                item.handleStatusChange = handleStatusChange;
                item.handleDelete = handleDelete;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var paginationConfig = Object.assign(_constants.PaginationConfig, {
            total: pagination.total_pages,
            onChange: function onChange(current, pageSize) {
                // pageSize是undefined，有待研究

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching || isPosting,
            paginationConfig: paginationConfig,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };

        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = TemplateList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/template_list.js
// module id = 1338
// module chunks = 0